import { observer } from 'mobx-react-lite'
import CustomAlert from '../../../../components/shared/CustomAlert'
import React from 'react'

import SubscriptionsStore from './../../Subscriptions.store'
import DateService from './../../../../shared/services/Date.service'
import UserProfileService from './../../../../shared/services/UserProfile.service'
import UsertypeService from './../../../../shared/services/Usertype.service'

const ucwords = str => str.replace(/^([a-z])|[\s_]+([a-z])/g, $1 => $1.toUpperCase())

const renderNonAgent = User => {
  let usertype = ucwords(
    ((User?.get('usertype_id') && UsertypeService.idToName(User?.get('usertype_id'))) || '').replace(/-/, ' ')
  )

  return (
    <CustomAlert className='text-center' color='warning'>
      You do not have an <strong>Agent</strong> account
      {usertype ? ` (${usertype})` : ''}.
      <br />
      You are inelligle for account subscriptions.
    </CustomAlert>
  )
}

const renderLegacySubscription = () => {
  return (
    <CustomAlert className='text-center' color='success'>
      Your agent subscription is <strong>active</strong>.
    </CustomAlert>
  )
}

const renderPreparingAccount = () => {
  return (
    <CustomAlert className='text-center' color='secondary'>
      Preparing Account...
    </CustomAlert>
  )
}

const renderInactiveSubscription = () => {
  return (
    <CustomAlert className='text-center' color='warning'>
      You do not have an active subscription.
    </CustomAlert>
  )
}

const renderInvalidPayment = () => {
  return (
    <CustomAlert className='text-center' color='danger'>
      You must add a valid payment method before you can upgrade your subscription.
    </CustomAlert>
  )
}

const renderCanceledSubscription = canceledAt => {
  return (
    <CustomAlert className='text-center' color='warning'>
      Your subscription was <strong>canceled</strong> on{' '}
      <strong>{DateService.dateOnlyToString(canceledAt, 'MM/DD/YYYY')}</strong>.
    </CustomAlert>
  )
}

const renderActiveSubscription = startedAt => {
  return (
    <CustomAlert className='text-center' color='success'>
      Your Signature Agent subscription is <strong>active</strong>
      {UserProfileService.isAssumed() &&
      UserProfileService.isA(['system-admin', 'internal-admin', 'internal-staff'], true) ? (
        <>
          &nbsp;since <strong>{DateService.dateOnlyToString(startedAt, 'MM/DD/YYYY')}</strong>
        </>
      ) : (
        <></>
      )}
      .
    </CustomAlert>
  )
}

const SubscriptionStatus = () => {
  const { User, subSource, customerId, subscriptionId, subscription, paymentMethods, isActive, isCanceled } =
      SubscriptionsStore,
    status = subscription?.sub_status

  if (User?.isA('non-agent')) return renderNonAgent(User)

  if (subSource && subSource?.merchant !== 'stripe' && subSource?.canceled_at) return renderLegacySubscription()

  if (!subscriptionId) {
    if (!customerId) return renderPreparingAccount()

    return (
      <>
        {renderInactiveSubscription()}
        {paymentMethods && paymentMethods.length ? <></> : renderInvalidPayment()}
      </>
    )
  }

  if (isCanceled()) return renderCanceledSubscription(subscription?.canceled_at)

  if (isActive()) return renderActiveSubscription(subscription?.started_at)

  if (status) {
    return (
      <CustomAlert
        className='text-center'
        color={status === 'active' ? 'success' : status === 'inactive' ? 'warning' : 'danger'}
      >
        Your Signature Agent subscription is <strong>{status}</strong>.
      </CustomAlert>
    )
  }

  return <></>
}

export default observer(SubscriptionStatus)
